import { render, staticRenderFns } from "./LmRadioBuilderUi.vue?vue&type=template&id=f24c6a90&"
import script from "./LmRadioBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmRadioBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports